var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0;}.cls-2{opacity:0.13;}.cls-3{fill:red;}.cls-4{opacity:0.1;}.cls-5{fill:#ff6700;}.cls-6{opacity:0.09;}.cls-7{opacity:0.03;}.cls-8{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01_\u9996\u9875") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4,
    y: 4,
    width: 56,
    height: 56
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 31.99,
    cy: 32,
    r: 28
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4,
    y: 8,
    width: 56,
    height: 48
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8,
    y: 4,
    width: 48,
    height: 56
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M9.64,33.18a1.76,1.76,0,0,1,1.84-1.68,1.76,1.76,0,0,1,1.85,1.68V53.32A1.76,1.76,0,0,1,11.48,55a1.76,1.76,0,0,1-1.84-1.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.67,5.32a1.9,1.9,0,0,1,2.62,0,1.8,1.8,0,0,1,0,2.57h0L7.17,33.59a1.9,1.9,0,0,1-2.62,0,1.79,1.79,0,0,1,0-2.57h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.71,5.28a1.87,1.87,0,0,1,2.61,0h0L59.46,31a1.82,1.82,0,0,1,0,2.59,1.88,1.88,0,0,1-2.63,0L30.71,7.87A1.84,1.84,0,0,1,30.71,5.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.08,12.9a1.8,1.8,0,0,1,1.78-1.82h7.46a1.83,1.83,0,0,1,1.85,1.81,1.81,1.81,0,0,1-1.77,1.83H44.93a1.84,1.84,0,0,1-1.85-1.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.44,13.65a1.86,1.86,0,0,1,3.69-.07v6.78A1.76,1.76,0,0,1,52.29,22a1.74,1.74,0,0,1-1.85-1.6V13.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M9.79,53.18a1.79,1.79,0,0,1,1.77-1.82H26.42a1.83,1.83,0,0,1,1.85,1.82A1.8,1.8,0,0,1,26.5,55H11.64a1.84,1.84,0,0,1-1.85-1.82Zm25.87,0a1.79,1.79,0,0,1,1.77-1.82H52.29a1.82,1.82,0,0,1,1.84,1.82A1.8,1.8,0,0,1,52.36,55H37.5a1.83,1.83,0,0,1-1.84-1.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24.57,43.21a1.77,1.77,0,0,1,1.85-1.64,1.75,1.75,0,0,1,1.85,1.61V53.29a1.78,1.78,0,0,1-1.85,1.64,1.75,1.75,0,0,1-1.85-1.61V43.21Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24.57,43.26a1.8,1.8,0,0,1,1.78-1.82H37.47a1.85,1.85,0,0,1,1.81,1.82,1.81,1.81,0,0,1-1.78,1.82H26.38a1.83,1.83,0,0,1-1.81-1.82Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M35.66,43.21a1.78,1.78,0,0,1,1.84-1.64,1.74,1.74,0,0,1,1.85,1.61V53.29a1.77,1.77,0,0,1-1.84,1.64,1.74,1.74,0,0,1-1.85-1.61V43.21ZM52.29,31.5a1.81,1.81,0,0,0-1.85,1.68V53.32a1.85,1.85,0,0,0,3.69,0h0V33.18a1.8,1.8,0,0,0-1.84-1.68Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8985c5c4.svg";
export { ForwardRef as ReactComponent };